<template>
	<div class="store-container">
		<el-row>
			<el-col :span='1'>
				<div class='store-title'>
					<button class="edit-btn" @click="edit">
						<span><img src="../assets/img/no-edit.png"></span>
						<span>返回</span>
					</button>
				</div>
			</el-col>
			<el-col :span='20' :offset='3'>
				<div class="store-from">
					<div class="store-from-title">请填写以下信息：</div>
					<el-form class="store-from-content" ref="form" :rules="rules" :model="form" label-width="120px">
						<el-form-item v-if="util.getIsHasField('cover')" :label="util.getKeyFrontValue('cover') + ':'" prop="cover">
							<el-upload action :http-request="coverUpload" list-type="picture-card"
								:on-preview="handlePictureCardPreview" :before-upload="beforeAvatarUpload"
								:on-exceed="handleExceed" :limit="1" :on-remove="handleRemove"
								:file-list="coverImgList">
								<div class="add-img">
									<img src="../assets/img/add-img.png" alt="">
									<div>点击上传</div>
								</div>
								<div slot="tip" class="el-upload__tip" :style="coverImgList.length > 0 ? 'margin-top: -20px;' : ''">支持jpg，jpeg，png格式，大小不得超过5M</div>
							</el-upload>
							<div>
								<el-progress v-if="showProgress" :percentage="progress" :color="color"
									style="width: 100px">
								</el-progress>
							</div>
						</el-form-item>
						<el-form-item v-if="util.getIsHasField('name')" :label="util.getKeyFrontValue('name') + ':'" prop="name">
							<el-row>
								<el-col :span='15'>
									<el-input class="w-600" v-model="form.name" maxlength="50" show-word-limit :placeholder="'请输入' + util.getKeyFrontValue('name')">
									</el-input>
								</el-col>
							</el-row>
						</el-form-item>
						<!-- 课程主题 -->
						<el-form-item v-if="util.getIsHasField('course_category_id')" :label="util.getKeyFrontValue('course_category_id') + ':'" prop="course_category_id">
							<el-select class="w-200 comment-margin-right-10" v-model="form.course_type"
								:placeholder="'请选择' + util.getKeyFrontValue('course_category_id')">
								<el-option label="劳动教育" value="labor"></el-option>
								<el-option label="综合实践" value="comprehensive"></el-option>
							</el-select>
							<el-select class="w-200" v-model="form.course_category_id"
								placeholder="请选择" v-show="form.course_type == 'labor'">
								<el-option v-for="(item,index) in laborOption" :key="item.id" :value="item.id" :label="item.name">
								</el-option>
							</el-select>
							<el-select class="w-200" v-model="form.course_category_id" placeholder="请选择"
								v-show="form.course_type == 'comprehensive'">
								<el-option v-for="(item,index) in comprehensiveOption" :key="item.id" :value="item.id"
									:label="item.name"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item v-if="util.getIsHasField('hour')" :label="util.getKeyFrontValue('hour') + ':'" prop="hour">
							<el-row>
								<el-col :span='5'>
									<el-input v-model.number="form.hour"  show-word-limit placeholder="请输入">
									</el-input>
								</el-col>
							</el-row>
						</el-form-item>
						<el-form-item v-if="util.getIsHasField('competition_course_to_apply')" :label="util.getKeyFrontValue('competition_course_to_apply') + ':'" prop="competition_course_to_apply">
							<el-checkbox-group v-model="form.competition_course_to_apply" class="el-checkbox-style" @change="stageChange">
								<el-checkbox label="小学">小学</el-checkbox>
								<el-checkbox label="初中">初中</el-checkbox>
							  <el-checkbox label="高中">高中</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
						<el-form-item v-if="util.getIsHasField('course_signature_ids') && course_signature_ids_is_access_multi_selection" :label="util.getKeyFrontValue('course_signature_ids') + ':'" prop="course_signature_ids">
							<el-select
								v-model="form.course_signature_ids"
								:multiple="course_signature_ids_is_access_multi_selection == 'multi'"
								filterable
								default-first-option
								placeholder="请输入或选择"
							>
								<el-option
									v-for="(item, index) in signatureOptions"
									:key="index"
									:label="item.name"
									:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item v-if="util.getIsHasField('introduction')" :label="util.getKeyFrontValue('introduction') + ':'" prop="introduction">
							<span slot="label">
								<span class="span-box">
									<span>{{util.getKeyFrontValue('introduction') + ':'}}</span>
									<!-- <p class="text-color" style="margin-top: -15px;">(300字以内)</p> -->
								</span>
							</span>
							<el-input type="textarea" :placeholder="'请输入' + util.getKeyFrontValue('introduction')" v-model="form.introduction" rows='10'
								maxlength="300" show-word-limit style="width: 610px;">
							</el-input>
						</el-form-item>
						<el-form-item v-if="util.getIsHasField('author')" :label="util.getKeyFrontValue('author') + ':'" prop="author">
							<el-input placeholder="请输入" v-model="form.author" style="width: 200px;"></el-input>
						</el-form-item>
						<el-form-item v-if="util.getIsHasField('author_recommend')" :label="util.getKeyFrontValue('author_recommend') + ':'" prop="author_recommend">
							<el-input type="textarea" placeholder="请输入" v-model="form.author_recommend" rows='10'
								maxlength="300" show-word-limit style="width: 610px;">
							</el-input>
						</el-form-item>
						<el-form-item v-if="util.getIsHasField('author_recommend') && authorRecommendSignatureOptions.length > 0" :label="util.getKeyFrontValue('author_recommend') + '标签:'" prop="competition_course_author_recommend_signature_ids">
							<el-select
								v-model="form.competition_course_author_recommend_signature_ids"
								multiple
								filterable
								default-first-option
								placeholder="请选择标签"
								style="width: 400px;"
							>
								<el-option
									v-for="(item, index) in authorRecommendSignatureOptions"
									:key="index"
									:label="item.name"
									:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item v-if="util.getIsHasField('competition_course_videos') && showVideoGroup" :label="util.getKeyFrontValue('competition_course_videos') + ':'" prop="competition_course_videos">
							<div class="upload-button">
								<el-button @click="showMoBan('video')">查看示例</el-button>
							</div>
							<GroupFileUpload
								:group-list.sync="competition_course_videos"
								type="video"
								:al-oss-url="alOssUrl"
								:util="util"
								@showFile="showFile"
							/>
							<!-- <el-upload action drag multiple :http-request="videoUpload" :file-list="videoList" :show-file-list="false"
								:before-upload="beforeVideoUpload">
								<div class="el-upload__text">
									<em style="margin-right: 20px">
										<img src="../assets/img/upload.png" style="width: 16px;height: 15px;margin-right: 10px">点击上传 
									</em>
									<span style="margin-right: 20px;color: #E5E5E5;">|</span>拖动文件到框内
									<p>支持MP4格式，单个视频文件大小限制1024M</p>
								</div>
							</el-upload>
							<fileGroupList :list_files_group.sync="competition_course_videos" :isGroup="true" :info_files.sync="videoList" />
							<div>
								<el-progress v-if="showProgressVideo" :percentage="progressVideo" :color="color"
									style="width: 600px">
								</el-progress>
							</div> -->
						</el-form-item>
						<el-form-item v-if="util.getIsHasField('competition_course_audios') && showAudioGroup" :label="util.getKeyFrontValue('competition_course_audios') + ':'" prop="competition_course_audios">
							<div class="upload-button">
								<el-button @click="showMoBan('audio')">查看示例</el-button>
							</div>
							<GroupFileUpload
								:group-list.sync="competition_course_audios"
								type="audio"
								:al-oss-url="alOssUrl"
								:util="util"
								@showFile="showFile"
							/>
							<!-- <el-upload action drag multiple :http-request="audioUpload" :file-list="audioList" :show-file-list="false"
								:before-upload="beforeAudioUpload">
								<div class="el-upload__text">
									<em style="margin-right: 20px">
										<img src="../assets/img/upload.png" style="width: 16px;height: 15px;margin-right: 10px">点击上传 
									</em>
									<span style="margin-right: 20px;color: #E5E5E5;">|</span>拖动文件到框内
									<p>支持MP3格式，单个音频文件大小限制50M</p>
								</div>
							</el-upload>
							<fileGroupList :list_files_group.sync="competition_course_audios" :isGroup="true" :info_files.sync="audioList" />
							<div>
								<el-progress v-if="showProgressAudio" :percentage="progressAudio" :color="color"
									style="width: 600px">
								</el-progress>
							</div> -->
						</el-form-item>
						<el-form-item v-if="util.getIsHasField('competition_course_files') && showFileGroup" :label="util.getKeyFrontValue('competition_course_files') + ':'" prop="competition_course_files">
							<div class="upload-button">
								<el-button @click="showMoBan('file')">查看示例</el-button>
							</div>
							<GroupFileUpload
								:group-list.sync="competition_course_files"
								type="file"
								:al-oss-url="alOssUrl"
								:util="util"
								@showFile="showFile"
							/>
							<!-- <el-upload 
								action 
								drag 
								multiple 
								:http-request="success" 
								:show-file-list="false"
								:before-upload="beforeAvatarUpload2">
								<div class="el-upload__text">
									<em style="margin-right: 20px">
										<img src="../assets/img/upload.png" style="width: 16px;height: 15px;margin-right: 10px">点击上传
									</em>
									<span style="margin-right: 20px;color: #E5E5E5;">|</span>拖动文件到框内
									<p>支持多个文件上传，格式支持PPT、Word、Excel、PDF，单个文件大小50M内。</p>
								</div>
							</el-upload>
							<fileGroupList :list_files_group.sync="competition_course_files" :isGroup="true" :info_files.sync="filesList" />
							<div>
								<el-progress v-if="showProgress2" :percentage="progress2" :color="color"
									style="width: 610px">
								</el-progress>
							</div> -->
						</el-form-item>
						<div class="store-from-title">请填写参赛人信息：</div>
						<el-form-item label="姓名:" prop="infoName">
							<el-row>
								<el-col :span='10'>
									<el-input v-model="form.infoName" placeholder="请输入参赛人信息"></el-input>
								</el-col>
							</el-row>
						</el-form-item>
						<el-form-item label="单位类型:" prop="affiliationType">
							<el-row>
								<el-col :span='10'>
									<el-select v-model="form.affiliationType" style="width: 100%;" @change="affiliationTypeChange">
										<el-option v-for="item in affiliationOptions" :label="item.name" :value="item.value"></el-option>
									</el-select>
								</el-col>
							</el-row>
						</el-form-item>
						<el-form-item label="所属单位:" prop="affiliation">
							<el-select filterable v-model="form.provincial_code" placeholder="请选择"
								value-key="id" class="w-100">
								<el-option v-for="item in provincialOption" :key="item.code" :label="item.name"
									:value="item.code">
								</el-option>
							</el-select>
							<span style="margin: 0 10px;">省</span>
							<el-select filterable v-model="form.municipal_code" placeholder="请选择"
								value-key="id" class="w-100">
								<el-option v-for="item in municipalOption" :key="item.code" :label="item.name"
									:value="item.code">
								</el-option>
							</el-select>
							<span style="margin: 0 10px;">市</span>
							<el-select filterable v-model="form.county_code" clearable placeholder="请选择"
								value-key="id" class="w-100">
								<el-option v-for="item in countyOption" :key="item.code" :label="item.name"
									:value="item.code">
								</el-option>
							</el-select>
							<span style="margin: 0 10px;">区/县</span>
							<el-input v-model="form.affiliation" placeholder="请输入学校名称" class="w-200"></el-input>
						</el-form-item>
						<el-form-item label="收货地址:" prop="address">
							<el-row>
								<el-col :span='15'>
									<el-input v-model="form.address" placeholder="请输入收货地址"></el-input>
								</el-col>
								<el-col :span='3'>
									<div style="font-size: 12px;color: #666666;margin-left: 5px;">用于奖品发放</div>
								</el-col>
							</el-row>
							<p class="store-text">提示：请上传符合国家法律法规的文件，如上传不符合法律法规的文件，一经查实，参赛作者将承担相关法律责任。</p>
						</el-form-item>
						<div style="padding-left: 120px;">
							<div style="margin-bottom: 15px;">
								<el-checkbox v-model="sureChecked" class="circular-checkbox">
									请勾选并确认
								</el-checkbox>
								《<span style="color: #FF383D;cursor: pointer;" @click.stop="showMoBan('sure')">课程征集大赛原创作品及素材授权声明确认</span>》
							</div>
							<el-button v-if='$route.query.id' type="primary" :loading="btnLoading" class='btn-primary' @click="submit('form')">修改</el-button>
							<el-button v-else type="primary" class='btn-primary' :loading="btnLoading" @click="submit('form')">立即提交</el-button>
						</div>
					</el-form>
				</div>
			</el-col>
		</el-row>
		<!-- <div>
			<div>
				请勾选并确认《<span style="color: #FF383D;cursor: pointer;">课程征集大赛原创作品及素材授权声明确认</span>》
			</div>
			<el-button v-if='$route.query.id' type="primary" :loading="btnLoading" class='btn-primary' @click="submit('form')">修改</el-button>
			<el-button v-else type="primary" class='btn-primary' :loading="btnLoading" @click="submit('form')">立即提交</el-button>
		</div> -->
		<!-- 文件预览 -->
		<el-dialog title="文件预览" :visible="showDoc == true || showPdf == true  || showImg == true || showMp4 == true || showMp3 == true" :width="fileWidth"
			class="dialog-div-pre-style" :before-close="closePreviewClick" center>
			<div v-if="showDoc == true" class="dialog-body-content-base-style">
				<iframe frameborder="0" :src="'https://view.officeapps.live.com/op/view.aspx?src=' + this.fileUrl"
					width='100%' height="800px">
				</iframe>
			</div>
			<div v-else-if="showPdf == true" class="dialog-body-content-base-style"
				style="justify-content: center; align-items: center">
				<embed :src="fileUrl" style="width: 100%; height: 80vh" />
			</div>
			<div v-else-if="showImg == true" class="dialog-body-content-base-style"
				style="justify-content: center; align-items: center;min-width: 40px;min-height: 40px;">
				<img :src="fileUrl" alt="" style="width: 100%;height: auto;max-height: 85vh;">
			</div>
			<div v-else-if="showMp4 == true" class="dialog-body-content-base-style"
				style="justify-content: center; align-items: center;">
				<video  style="max-height: 80vh;" :src="fileUrl" controls="controls" width="100%" object-fit='cover'></video>
			</div>
			<div v-else-if="showMp3 == true" class="dialog-body-content-base-style"
				style="justify-content: center; align-items: center;min-width: 300px;">
				<audio :src="fileUrl" controls="controls" width="100%" object-fit='cover'></audio>
			</div>
		</el-dialog>
		<el-dialog :title="exampleTitle" :visible.sync="visible" width="700px" center append-to-body>
			<div v-html="exampleContent"></div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		client
	} from '@/util/js/ali_oss.js'
	import editor from '../components/editor.vue'
	import fileGroupList from '../components/file_group_list.vue'
	import GroupFileUpload from '../components/GroupFileUpload.vue'
	export default {
		name: 'index',
		components: {
			editor,
			fileGroupList,
			GroupFileUpload
		},
		data() {
			return {
				rules: {
					cover: [{
						required: true,
						message: '请上传' + this.util.getKeyFrontValue('cover'),
						trigger: 'change',
						validator: (rule, value, callback) => {
							if (this.coverImgList.length == 0) {
								callback(new Error('请上传' + this.util.getKeyFrontValue('cover')))
							} else {
								callback()
							}
						},
					}],
					name: [{
						required: true,
						message: '请输入' + this.util.getKeyFrontValue('name'),
						trigger: 'change'
					}],
					course_category_id: [{
						required: true,
						message: '请选择' + this.util.getKeyFrontValue('category'),
						trigger: 'change'
					}],
					hour: [{
						required: true,
						message: '请输入' + this.util.getKeyFrontValue('hour'),
						trigger: 'change'
					}],
					competition_course_to_apply: [{
						required: true,
						message: '请选择' + this.util.getKeyFrontValue('competition_course_to_apply'),
						trigger: 'change',
						validator: (rule, value, callback) => {
							console.log(this.form.competition_course_to_apply)
							if (this.form.competition_course_to_apply.length == 0) {
								callback(new Error('请选择' + this.util.getKeyFrontValue('competition_course_to_apply')))
							} else {
								callback()
							}
						},
					}],
					introduction: [{
						required: true,
						message: '请填写' + this.util.getKeyFrontValue('introduction'),
						trigger: 'change'
					}],
					author: [{
						required: true,
						message: '请填写' + this.util.getKeyFrontValue('author'),
						trigger: 'change'
					}],
					author_recommend: [{
						required: true,
						message: '请填写' + this.util.getKeyFrontValue('author_recommend'),
						trigger: 'change'
					}],
					competition_course_author_recommend_signature_ids: [{
						required: true,
						message: '请选择' + this.util.getKeyFrontValue('competition_course_author_recommend_signature_ids'),
						trigger: 'change'
					}],
					competition_course_videos: [{
						required: true,
						message: '请上传' + this.util.getKeyFrontValue('competition_course_videos'),
						trigger: 'change',
						validator: (rule, value, callback) => {
							let num = 0;
							this.competition_course_videos.forEach(item => {
								num = num + item.list.length
							})
							if (num == 0) {
								callback(new Error('请上传' + this.util.getKeyFrontValue('competition_course_videos')))
							} else {
								callback()
							}
						},
					}],
					competition_course_audios: [{
						required: true,
						message: '请上传' + this.util.getKeyFrontValue('competition_course_audios'),
						trigger: 'change',
						validator: (rule, value, callback) => {
							let num = 0;
							this.competition_course_audios.forEach(item => {
								num = num + item.list.length
							})
							if (num == 0) {
								callback(new Error('请上传' + this.util.getKeyFrontValue('competition_course_audios')))
							} else {
								callback()
							}
						},
					}],
					competition_course_files: [{
						required: true,
						message: '请上传' + this.util.getKeyFrontValue('competition_course_files'),
						trigger: 'change',
						validator: (rule, value, callback) => {
							let num = 0;
							this.competition_course_files.forEach(item => {
								num = num + item.list.length
							})
							if (num == 0) {
								callback(new Error('请上传' + this.util.getKeyFrontValue('competition_course_files')))
							} else {
								callback()
							}
						}
					}],
					course_signature_ids: [{
						required: true,
						message: '请选择' + this.util.getKeyFrontValue('course_signature_ids'),
						trigger: 'change'
					}],
					infoName: [{
						required: true,
						message: '请填写姓名',
						trigger: 'change'
					}],
					affiliation: [{
						required: true,
						trigger: 'blur',
						validator: (rule, value, callback) => {
							if (this.form.provincial_code == '') {
								callback(new Error('请选择省'))
							} else if (this.form.municipal_code == '') {
								callback(new Error('请选择市'))
							} else if (this.form.county_code == '') {
								callback(new Error('请选择区县'))
							} else if(value == '') {
								callback(new Error('请填写所属单位'))
							} else {
								callback()
							}
						}
					}],
					affiliationType: [{
						required: true,
						message: '请选择单位类型',
						trigger: 'change'
					}],
					provincial_code: [{
						required: true,
						message: '请选择省',
						trigger: 'change'
					}],
					municipal_code: [{
						required: true,
						message: '请选择市',
						trigger: 'change'
					}],
					county_code: [{
						required: true,
						message: '请选择所属教育局',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '请填写收货地址',
						trigger: 'change'
					}]
				},
				isUpdateInitRegion: false,
				form: {
					cover: '',
					//标题
					name: '',
					// 课程类型
					course_type: '',
					// 课程主题
					course_category_id: '',
					//学时
					hour:'',
					// 课程标签
					course_signature_ids: '',
					// 适用学段
					competition_course_to_apply: [],
					// 课程简介
					introduction: '',
					author: '',
					// 作者自荐
					author_recommend: '',
					// 作者自荐标签
					competition_course_author_recommend_signature_ids: [],
					// 省
					provincial_code: JSON.parse(sessionStorage.getItem('userInfo'))?.provincial_code || '',
					//市
					municipal_code: '',
					// 区
					county_code: '',

					//参赛人信息
					infoName: '',
					affiliationType: '',
					affiliation: '',
					address: '',
				},
				// 课程标签单选还是多选 mounted里定义
				course_signature_ids_is_access_multi_selection: '',
				// 适用学段单选还是多选 mounted里定义
				competition_course_to_apply_is_access_multi_selection: '',
				btnLoading: false,
				provincialOption: [],
				municipalOption: [],
				countyOption: [],
				// 课程主题
				// 劳动教育
				laborOption: [],
				// 综合实践
				comprehensiveOption: [],
				categoryOptions: [],
				//课程封面
				coverImgList: [],
				//课程附件
				filesList: [],
				// 课程视频
				videoList: [],
				// 课程音频
				audioList: [],
				// 单位类型列表
				affiliationOptions: [
					{
						name: '学校',
						value: 'school'
					},
					{
						name: '基地',
						value: 'practice_base'
					},
					{
						name: '机构',
						value: 'research_institution'
					}
				],
				// 课程附件
				competition_course_files: [],
				// 课程视频
				competition_course_videos: [],
				// 课程音频
				competition_course_audios: [],
				// 是否显示课程附件
				showFileGroup: false,
				// 是否显示课程视频
				showVideoGroup: false,
				// 是否显示课程音频
				showAudioGroup: false,
				// 课程标签
				signatureOptions: [],
				// 作者自荐标签
				authorRecommendSignatureOptions: [],

				color: '#67C23A',
				showProgress: false, //进度条的显示
				progress: 0, //进度条数据
				showProgress2: false, //进度条的显示
				progress2: 0, //进度条数据
				
				showProgressAudio: false,
				progressAudio: 0,
				showProgressVideo: false,
				progressVideo: 0,

				//文件预览
				showDoc: false,
				showPdf: false,
				showImg: false,
				showMp4: false,
				showMp3: false,
				fileUrl: "",
				fileWidth: '',

				isUpdate: false,
				
				// 查看实例
				visible: false,
				exampleTitle: '查看示例',
				exampleContent: '',
				// 确认勾选底部版权声明
				sureChecked: false,

			}
		},
		methods: {
			showMoBan(val) {
				if (val == 'sure') {
					this.exampleTitle = '课程征集大赛原创作品及素材授权声明确认'
						this.HttpUtil.Get(this.api.util.competitionCourseInformationDetail, {
						kind: val,
						competition_course_poster_id: sessionStorage.getItem('competition_course_poster_id')
					}, {
						split_loginRole: true
					}).then(res => {
						this.exampleContent = res.competition_course_information?.description || '暂未上传内容！'
						this.visible = true
					})
				} else {
					this.exampleTitle = '查看示例'
					this.HttpUtil.Get(this.api.util.competitionCourseExampleDetail, {
						competition_course_poster_id: sessionStorage.getItem('competition_course_poster_id'),
						kind: val
					}, {
						split_loginRole: true
					}).then(res => {
						this.exampleContent = res.competition_course_example?.description || '暂未上传内容！'
						this.visible = true
					})
				}
			},

			edit() {
				this.$router.go(-1)
			},
			submit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.coverImgList.length == 0 && this.util.getIsHasField('cover')) {
							this.$message.error('请上传' + this.util.getKeyFrontValue('cover') + '!');
							return
						}
						// if (this.form.competition_course_to_apply.length == 0) {
						// 	this.$message.error('请选择' + this.util.getKeyFrontValue('competition_course_to_apply') + '!');
						// 	return
						// }
						// if(this.form.introduction == ''){
						// 	this.$message.error('请输入' + this.util.getKeyFrontValue('introduction') + '!');
						// 	return
						// }
						// if(!this.form.author_recommend){
						// 	this.$message.error('请输入' + this.util.getKeyFrontValue('author_recommend') + '！');
						// 	return
						// }
						// if (this.form.competition_course_author_recommend_signature_ids.length == 0) {
						// 	this.$message.error('请选择' + this.util.getKeyFrontValue('competition_course_author_recommend_signature_ids') + '！');
						// 	return
						// }
						if (!this.sureChecked) {
							this.$message.error('请先勾选并确认《课程征集大赛原创作品及素材授权声明确认》!');
							return
						}
						this.$confirm('课程内容一经提交，无法修改、删除。请谨慎提交！', '提示', {
							confirmButtonText: '提交',
							cancelButtonText: '取消',
						}).then(() => {
							let competition_course_to_apply = []
							if (this.form.competition_course_to_apply.includes('小学')) {
								for (let i = 0; i < 6; i++) {
									competition_course_to_apply.push({
										stage: 1,
										grade: i + 1,
									})
								}
							}
							if (this.form.competition_course_to_apply.includes('初中')) {
								for (let i = 0; i < 3; i++) {
									competition_course_to_apply.push({
										stage: 2,
										grade: i + 1,
									})
								}
							}
							if (this.form.competition_course_to_apply.includes('高中')) {
								for (let i = 0; i < 3; i++) {
									competition_course_to_apply.push({
										stage: 3,
										grade: i + 1,
									})
								}
							}
							this.btnLoading = true
							let competition_course = {
								cover: this.coverImgList[0].path,
								name: this.form.name,
								course_category_id: this.form.course_category_id,
								hour: this.form.hour,
								introduction: this.form.introduction,
								author_recommend: this.form.author_recommend,
								author: this.form.author,
								course_signature_ids: this.form.course_signature_ids,
								competition_course_author_recommend_signature_ids: this.form.competition_course_author_recommend_signature_ids,
								competition_course_to_apply: competition_course_to_apply,
								competition_course_files: this.competition_course_files,
								competition_course_videos: this.competition_course_videos,
								competition_course_audios: this.competition_course_audios,
							}
							let competition_course_author = {
								name: this.form.infoName,
								affiliation_type: this.form.affiliationType,
								affiliation: this.form.affiliation,
								provincial_code: this.form.provincial_code,
								municipal_code: this.form.municipal_code,
								county_code: this.form.county_code,
								address: this.form.address,
							}
							let obj = {
								competition_course: competition_course,
								competition_course_author: competition_course_author
							}
							if (this.isUpdate) {
								this.HttpUtil.Post(this.api.staff.competitionCourseUpdate, obj, {
									competition_course_poster_id: sessionStorage.getItem('competition_course_poster_id'),
									id: this.$route.query.id
								}).then(res => {
									this.$message.success('提交成功')
									this.$router.push({
										name: 'course'
									})
								}).catch(err => {
									this.btnLoading = false
								})
							} else {
								this.HttpUtil.Post(this.api.staff.competitionCourseStore, obj, {
									competition_course_poster_id: sessionStorage.getItem('competition_course_poster_id')
								}).then(res => {
									this.$message.success('提交成功')
									this.$router.push({
										name: 'course'
									})
								}).catch(err => {
									this.btnLoading = false
								})
							}
						}).catch(() => {
							this.btnLoading = false
							return
						})
					} else {
						return false;
					}
				});

			},
			//编辑
			getDetail() {
				this.HttpUtil.Get(this.api.staff.competitionCourseDetail, {
					id: this.$route.query.id
				}).then((res) => {
					let competition_course = res.competition_course
					this.coverImgList.push({
						name: competition_course.cover,
						url: this.alOssUrl + competition_course.cover,
						path: competition_course.cover
					})
					this.form.name = competition_course.name
					this.form.hour = competition_course.hour
					this.form.course_signature_ids = []
					competition_course.m_competition_course_to_course_signature.forEach(item => {
						this.form.course_signature_ids.push(item.course_signature_id)
					})
					this.form.course_type = competition_course.o_course_category?.kind || ''
					this.form.course_category_id = competition_course.o_course_category?.id || ''
					this.form.introduction = competition_course.introduction
					this.form.author = competition_course.author
					this.form.author_recommend = competition_course.author_recommend
					this.form.competition_course_author_recommend_signature_ids = competition_course.competition_course_author_recommend_signature_ids
					this.form.competition_course_to_apply = []
					competition_course.m_competition_course_to_apply.forEach(item => {
						if(item.stage == 1 && !this.form.competition_course_to_apply.includes('小学')) {
							this.form.competition_course_to_apply.push('小学')
						} else if(item.stage == 2 && !this.form.competition_course_to_apply.includes('初中')) {
							this.form.competition_course_to_apply.push('初中')
						} else if(item.stage == 3 && !this.form.competition_course_to_apply.includes('高中')) {
							this.form.competition_course_to_apply.push('高中')
						}
					})
					this.form.address = competition_course?.o_competition_course_author?.address || ''
					this.form.infoName = competition_course?.o_competition_course_author?.name || ''
					this.form.affiliationType = competition_course?.o_competition_course_author?.affiliation_type || ''
					this.form.affiliation = competition_course?.o_competition_course_author?.affiliation || ''

					this.isUpdateInitRegion = true
					this.form.provincial_code = competition_course?.o_competition_course_author?.provincial_code || ''
					this.form.municipal_code = competition_course?.o_competition_course_author?.municipal_code || ''
					this.form.county_code = competition_course?.o_competition_course_author?.county_code || ''

					if (res.competition_course_file_group.length > 0) {
						this.competition_course_files = []
						res.competition_course_file_group.forEach(item => {
							this.competition_course_files.push({
								group: {
									name: item.name,
									id: item.id,
									weigh: item.weigh,
								},
								list: []
							})
							res.competition_course_file.forEach(file => {
								if(file.competition_course_file_group_id == item.id) {
									this.competition_course_files[this.competition_course_files.length - 1].list.push(file)
								}
							})
						})
						this.showFileGroup = true
					} else {
						this.getConfigFileGroup('file')
					}
					
					if (res.competition_course_video_group.length > 0) {
						this.competition_course_videos = []
						res.competition_course_video_group.forEach(item => {
							this.competition_course_videos.push({
								group: {
									name: item.name,
									id: item.id,
									weigh: item.weigh,
								},
								list: []
							})
							res.competition_course_video.forEach(video => {
								if(video.competition_course_video_group_id == item.id) {
									this.competition_course_videos[this.competition_course_videos.length - 1].list.push(video)
								}
							})
						})
						this.showVideoGroup = true
					} else {
						this.getConfigFileGroup('video')
					}

					if (res.competition_course_audio_group.length > 0) {
						this.competition_course_audios = []
						res.competition_course_audio_group.forEach(item => {
							this.competition_course_audios.push({
								group: {
									name: item.name,
									id: item.id,
									weigh: item.weigh,
								},
								list: []
							})
							res.competition_course_audio.forEach(audio => {
								if(audio.competition_course_audio_group_id == item.id) {
									this.competition_course_audios[this.competition_course_audios.length - 1].list.push(audio)
								}
							})
						})
						this.showAudioGroup = true
					} else {
						this.getConfigFileGroup('audio')
					}

					this.btnLoading = false
				})
			},
			// 课程封面图片上传方法
			coverUpload(obj) {
				let that = this
				var fileName = this.util.getFileName() + obj.file.name; //定义唯一的文件名
				//定义唯一的文件名
				client().multipartUpload(fileName, obj.file, {
					progress: function(p) {
						//p进度条的值
						setTimeout(function() {
							that.showProgress = true;
							that.progress = Math.floor(p * 100);
						}, 300)
					}
				}).then(
					result => {
						if (result.res.statusCode == 200) {
							let nweObj = {
								name: obj.file.name,
								url: this.alOssUrl + result.name,
								path: fileName,
								size: obj.file.name.size
							}
							delete this.rules.cover;
							this.coverImgList.push(nweObj)
						} else {
							this.$message.error('上传失败！');
						}
					})
			},
			// 课程视频上传方法
			videoUpload(obj) {
				let that = this
				var fileName = this.util.getFileName() + obj.file.name; //定义唯一的文件名
				let size = this.util.getFileSize(obj.file.size)
				//定义唯一的文件名
				client().multipartUpload(fileName, obj.file, {
					progress: function(p) {
						//p进度条的值
						setTimeout(function() {
							that.showProgressVideo = true;
							that.progressVideo = Math.floor(p * 100);
						}, 300)
					}
				}).then(
					result => {
						if (result.res.statusCode == 200) {
							let nweObj = {
								name: obj.file.name,
								url: this.alOssUrl + result.name,
								path: fileName,
								size: size
							}
							delete this.rules.videoList;
							this.videoList.push(nweObj)
							// 分组处理
							if (this.competition_course_videos.length == 0) {
								let dataInfo = {
									group: { name: "未分组", weigh: 0 },
									list: []
								}
								dataInfo.list.push(nweObj)
								this.competition_course_videos.push(dataInfo)
							} else {
								let hasUnassignedGroup = this.competition_course_videos.some(item => item.group.name === "未分组");
								if (hasUnassignedGroup) {
									this.competition_course_videos.forEach((item) => {
										if (item.group.name == "未分组") {
											nweObj.weigh = item.list.length
											item.list.push(nweObj)
										}
									})
								} else {
									let dataInfo = {
										group: { name: "未分组", weigh: 0 },
										list: []
									}
									dataInfo.list.push(nweObj)
									this.competition_course_videos.push(dataInfo)
								}
							}
						} else {
							this.$message.error('上传失败！');
						}
					})
			},
			// 课程音频上传方法
			audioUpload(obj) {
				let that = this
				var fileName = this.util.getFileName() + obj.file.name; //定义唯一的文件名
				let size = this.util.getFileSize(obj.file.size)
				//定义唯一的文件名
				client().multipartUpload(fileName, obj.file, {
					progress: function(p) {
						//p进度条的值
						setTimeout(function() {
							that.showProgressAudio = true;
							that.progressAudio = Math.floor(p * 100);
						}, 300)
					}
				}).then(
					result => {
						if (result.res.statusCode == 200) {
							let nweObj = {
								name: obj.file.name,
								url: this.alOssUrl + result.name,
								path: fileName,
								size: size
							}
							delete this.rules.audioList;
							this.audioList.push(nweObj)
							// 分组处理
							if (this.competition_course_audios.length == 0) {
								let dataInfo = {
									group: { name: "未分组", weigh: 0 },
									list: []
								}
								dataInfo.list.push(nweObj)
								this.competition_course_audios.push(dataInfo)
							} else {
								let hasUnassignedGroup = this.competition_course_audios.some(item => item.group.name === "未分组");
								if (hasUnassignedGroup) {
									this.competition_course_audios.forEach((item) => {
										if (item.group.name == "未分组") {
											nweObj.weigh = item.list.length
											item.list.push(nweObj)
										}
									})
								} else {
									let dataInfo = {
										group: { name: "未分组", weigh: 0 },
										list: []
									}
									dataInfo.list.push(nweObj)
									this.competition_course_audios.push(dataInfo)
								}
							}
						} else {
							this.$message.error('上传失败！');
						}
					})
			},
			handleRemove(file, fileList) {
				this.coverImgList = []
			},
			handlePictureCardPreview(file) {
				this.showFile(file.path)
			},
			beforeAvatarUpload(file) {
				// 限制图片大小格式
				const isJPG = file.type === 'image/jpg';
				const isJPEG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isJPG && !isJPEG && !isPNG) {
					this.$message.error('上传图片只能是 JPG,JPEG和PNG 格式!');
				}
				if (!isLt5M) {
					this.$message.error('上传图片大小不能超过5MB!');
				}
				return isJPG && isLt5M || isPNG || isJPEG;
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制上传 1 个文件！`);
			},
			// 课程附件上传方法
			success(obj) {
				let that = this
				var fileName = this.util.getFileName() + obj.file.name; //定义唯一的文件名
				let size = this.util.getFileSize(obj.file.size)
				//定义唯一的文件名，打印出来的uid其实就是时间戳
				client().multipartUpload(fileName, obj.file, {
					progress: function(p) {
						//p进度条的值
						setTimeout(function() {
							that.showProgress2 = true;
							that.progress2 = Math.floor(p * 100);
						}, 300)
					}
				}).then(
					result => {
						console.log('result', result)
						if (result.res.statusCode == 200) {
							let nweObj = {
								name: obj.file.name,
								url: this.alOssUrl + result.name,
								path: result.name,
								size: size
							}
							this.filesList.push(nweObj)
							if (this.competition_course_files.length == 0) {
								let dataInfo = {
									group: {
										name: "未分组",
										weigh: 0,
									},
									list: []
								}
								dataInfo.list.push(nweObj)
								this.competition_course_files.push(dataInfo)

							} else {
								//如果没有未分组需要新建未分组
								let hasUnassignedGroup = this.competition_course_files.some(item => item.group.name === "未分组");
								if (hasUnassignedGroup) {
									this.competition_course_files.forEach((item, index) => {
										if (item.group.name == "未分组") {
											nweObj.weigh = item.list.length
											item.list.push(nweObj)
										}
									})
								} else {
									let dataInfo = {
										group: {
											name: "未分组",
											weigh: 0,
										},
										list: []
									}
									dataInfo.list.push(nweObj)
									this.competition_course_files.push(dataInfo)
								}
							}
							console.log('competition_course_files', this.competition_course_files)
						} else {
							this.$message.error('上传失败！');
						}
					})
			},
			// 视频上传
			beforeVideoUpload(file) {
				const isLt1024M = file.size / 1024 / 1024 < 1024;
				if (!isLt1024M) {
					this.$message.error('上传文件大小不能超过 1024MB!');
					return false
				}
				const fileName = file.name;
				const format = 'mp4'
				//文件后缀
				const ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
				// 允许mp4
				let isExtent = true
				format.split(',').map((item) => {
					//只要有一个就匹配就返回false
					if (ext == item) {
						isExtent = false
						return isExtent
					}
				})
				if (isExtent) {
					this.$message.error(`当前文件只能上传${format}格式！`);
					return false
				} else {
					return true
				}
			},
			// 视频上传
			beforeAudioUpload(file) {
				const isLt50M = file.size / 1024 / 1024 < 50;
				if (!isLt50M) {
					this.$message.error('上传文件大小不能超过 50MB!');
					return false
				}
				const fileName = file.name;
				// const format = 'ppt,pptx'
				const format = 'mp3'
				//文件后缀
				const ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
				// 允许jpg
				let isExtent = true
				format.split(',').map((item) => {
					//只要有一个就匹配就返回false
					if (ext == item) {
						isExtent = false
						return isExtent
					}
				})
				if (isExtent) {
					// this.$message.error(`当前文件只能上传PPT格式！`);
					this.$message.error(`当前文件只能上传MP3格式！`);
					return false
				} else {
					return true
				}
				
				// const isLt500M = file.size / 1024 / 1024 < 500;
				// if (!isLt500M) {
				// 	this.$message.error('上传文件大小不能超过 500MB!');
				// 	return false
				// }
				// const fileName = file.name;
				// const format = 'mp3'
				// //文件后缀
				// const ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
				// // 允许mp3
				// let isExtent = true
				// format.split(',').map((item) => {
				// 	//只要有一个就匹配就返回false
				// 	if (ext == item) {
				// 		isExtent = false
				// 		return isExtent
				// 	}
				// })
				// if (isExtent) {
				// 	this.$message.error(`当前文件只能上传${format}格式！`);
				// 	return false
				// } else {
				// 	return true
				// }
			},
			beforeAvatarUpload2(file) {
				const isLt50M = file.size / 1024 / 1024 < 50;
				if (!isLt50M) {
					this.$message.error('上传文件大小不能超过 50MB!');
					return false
				}
				const fileName = file.name;
				const format = 'ppt,pptx,doc,docx,xls,xlsx,pdf'
				//文件后缀
				const ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
				// 允许PPT、Word、Excel、PDF
				let isExtent = true
				format.split(',').map((item) => {
					//只要有一个就匹配就返回false
					if (ext == item) {
						isExtent = false
						return isExtent
					}
				})
				if (isExtent) {
					this.$message.error(`当前文件只能上传PPT、Word、Excel、PDF格式！`);
					return false
				} else {
					return true
				}
			},
			
			delList(type, id) {
				if(type == 'file') {
					this.filesList.map((item, index) => {
						if (item.id == id) {
							this.filesList.splice(index, 1)
						}
					})
				} else if(type == 'video') {
					this.videoList.map((item, index) => {
						if (item.id == id) {
							this.videoList.splice(index, 1)
						}
					})
				} else if(type == 'audio') {
					this.audioList.map((item, index) => {
						if (item.id == id) {
							this.audioList.splice(index, 1)
						}
					})
				}
				
			},
			//查看文件
			showFile(url) {
				let type = url;
				this.fileUrl = this.alOssUrl + url
				if (type.indexOf("doc") != -1 || type.indexOf("docx") != -1 || type.indexOf("xls") != -1 || type.indexOf(
						"xlsx") != -1 || type.indexOf("pptx") != -1 || type.indexOf("ppt") != -1) {
					this.fileWidth = '80%'
					this.showDoc = true
				} else if (type.indexOf("pdf") != -1) {
					this.fileWidth = '80%'
					this.showPdf = true
				} else if (type.indexOf("jpg") != -1 || type.indexOf("png") != -1 || type.indexOf("jpeg") != -1) {
					this.showImg = true
					let image = new Image();
					image.src = this.alOssUrl + url;
					image.onload = () => {
						this.fileWidth = image.width + 'px'
					};
				} else if (type.indexOf("mp4") != -1) {
					this.fileWidth = '70%'
					this.showMp4 = true
				} else if (type.indexOf("mp3") != -1) {
					this.fileWidth = '360px'
					this.showMp3 = true
				}else {
					this.$message("当前文件暂不支持预览")
				}
			},
			closePreviewClick() {
				if (this.showDoc == true) {
					this.showDoc = false
				} else if (this.showPdf == true) {
					this.showPdf = false
				} else if (this.showImg == true) {
					this.showImg = false
				} else if (this.showMp4 == true) {
					this.showMp4 = false
				} else if (this.showMp3 == true) {
					this.showMp3 = false
				}
			},
			affiliationTypeChange() {
				this.form.affiliation = ''
			},
			getMunicipalList(provincial_code) {
				this.HttpUtil.Get(this.api.common.regionList, {
					limit: 0,
					pcode: provincial_code
				}, {}, {
					commonApi: true
				}).then(res => {
					this.municipalOption = res.list
				})
			},
			// 获取课程主题
			getCourseCategoryTree() {
				return new Promise((resolve, reject) => {
					this.HttpUtil.Get(this.api.common.courseCategoryTree, {
						// region_code: JSON.parse(sessionStorage.getItem('region_code'))
					}, {}, {
						commonApi: true
					}).then(res => {
						this.categoryOptions = res.tree
						if (res.tree && res.tree.length > 0) {
							res.tree.forEach(item => {
								if (item.kind == 'labor') {
									// 劳动教育
									this.laborOption = item.children
								} else if (item.kind == 'comprehensive') {
									// 综合实践
									this.comprehensiveOption = item.children
								}
							})
						}
						resolve(res.tree)
					}).catch(err => {
						reject(err)
					})
				})
			},
			// 获取添加课程时单位类型列表
			getAffiliationList() {
				let competition_course_detail = JSON.parse(sessionStorage.getItem('competition_course_detail'))
				if(competition_course_detail?.config?.affiliation_type?.length > 0) {
					this.affiliationOptions = []
					competition_course_detail.config.affiliation_type.forEach(item => {
						switch (item) {
							case 'school':
								this.affiliationOptions.push({name:'学校',value: 'school'})
								break;
							case 'practice_base':
								this.affiliationOptions.push({name:'基地',value: 'practice_base'})
								break;
							case 'research_institution':
								this.affiliationOptions.push({name:'机构',value: 'research_institution'})
								break;
						}
					})
					this.affiliationOptions.sort((a, b) => a.value - b.value)
					this.form.affiliationType = this.affiliationOptions[0].value
				} else {
					this.affiliationOptions = [{name: '学校',value: 'school'},{name: '基地',value: 'practice_base'},{name: '机构',value: 'research_institution'}]
					this.form.affiliationType = 'school'
				}
			},
			stageChange(val) {
				// 不能删 mounted里有根据情况定义这个字段
				if (this.competition_course_to_apply_is_access_multi_selection == 'multi') {
					// 多选
					this.form.competition_course_to_apply = val
				} else {
					// 单选
					if (val.length > 0) {
						this.form.competition_course_to_apply = [val[val.length - 1]]
					} else {
						this.form.competition_course_to_apply = []
					}
				}
			},
			getSignatureList() {
				this.HttpUtil.Get(this.api.common.courseSignatureList, {
					limit: 0,
				}, {}, {
					commonApi: true
				}).then(res => {
					this.signatureOptions = res.list
				})
			},
			getAuthorRecommendSignatureList() {
				this.HttpUtil.Get(this.api.util.competitionCourseAuthorRecommendSignatureList, {
					limit: 0,
				}, {
					split_loginRole: true
				}).then(res => {
					this.authorRecommendSignatureOptions = res.list
				})
			},
			getProvincialList() {
				this.HttpUtil.Get(this.api.common.regionList, {
					limit: 0,
					pcode: 0
				}, {}, {
					commonApi: true
				}).then(res => {
					this.provincialOption = res.list
				})
			},
			getFileGroup() {
				this.HttpUtil.Get(this.api.util.competitionCourseFileDefaultGroupList, {
					competition_course_poster_id: sessionStorage.getItem('competition_course_poster_id')
				}, {
					split_loginRole: true
				}).then(res => {
					if (res.list.length > 0) {
						this.showFileGroup = true
					}
					res.list.forEach(item => {
						this.competition_course_files.push({
							group: {
								id: item.id,
								name: item.name,
								weigh: item.weigh
							},
							list: []
						})
					})
				})
			},
			getVideoGroup() {
				this.HttpUtil.Get(this.api.util.competitionCourseVideoDefaultGroupList, {
					competition_course_poster_id: sessionStorage.getItem('competition_course_poster_id')
				}, {
					split_loginRole: true
				}).then(res => {
					if (res.list.length > 0) {
						this.showVideoGroup = true
					}
					res.list.forEach(item => {
						this.competition_course_videos.push({
							group: {
								id: item.id,
								name: item.name,
								weigh: item.weigh
							},
							list: []
						})
					})
				})
			},
			getAudioGroup() {
				this.HttpUtil.Get(this.api.util.competitionCourseAudioDefaultGroupList, {
					competition_course_poster_id: sessionStorage.getItem('competition_course_poster_id')
				}, {
					split_loginRole: true
				}).then(res => {
					if (res.list.length > 0) {
						this.showAudioGroup = true
					}
					res.list.forEach(item => {
						this.competition_course_audios.push({
							group: {
								id: item.id,
								name: item.name,
								weigh: item.weigh
							},
							list: []
						})
					})
				})
			},
			getConfigFileGroup(type) {
				if (type == 'all') {
					this.getFileGroup()
					this.getVideoGroup()
					this.getAudioGroup()
				} else if (type == 'file') {
					this.getFileGroup()
				} else if (type == 'video') {
					this.getVideoGroup()
				} else if (type == 'audio') {
					this.getAudioGroup()
				}
			},
		},
		mounted() {
			delete this.rules.cover;
			delete this.rules.fileList;
			this.util.setOssConfig()
			// 可以多选的字段
			let arr = JSON.parse(sessionStorage.getItem('fieldOptions'))
			arr.forEach((item => {
				if (item.is_access_multi_selection) {
					this[`${item.name}_is_access_multi_selection`] = item.selection
				}
			}))
			if (this.course_signature_ids_is_access_multi_selection == 'single') {
				this.form.course_signature_ids = ''
			} else if (this.course_signature_ids_is_access_multi_selection == 'multi') {
				this.form.course_signature_ids = []
			}
			
			// 获取课程标签
			this.getSignatureList()
			// 获取作者自荐标签
			this.getAuthorRecommendSignatureList()
			// 获取超管配置的课程主题
			this.getCourseCategoryTree()
			// 获取超管配置的单位类型列表
			this.getAffiliationList()

			// 获取省
			this.getProvincialList()
			
			sessionStorage.setItem("store", true)
			if (this.$route.query.id != undefined) {
				this.isUpdate = true
				this.getDetail()
			} else {
				// 获取文件预设的分组
				this.getConfigFileGroup('all')
			}
		},
		watch: {
			'form.course_type': {
				handler(res) {
					if (res === 'labor') {
						if (this.laborOption.length > 0) this.form.course_category_id = this.laborOption[0].id
						else this.form.course_category_id = ''
					} else if (res === 'comprehensive') {
						if (this.comprehensiveOption.length > 0) this.form.course_category_id = this.comprehensiveOption[0].id
						else this.form.course_category_id = ''
					}
				}
			},
			'form.provincial_code': {
				handler(res) {
					this.municipalOption = [];
					this.countyOption = [];
					if (!this.isUpdateInitRegion) {
						this.form.municipal_code = '';
						this.form.county_code = '';
					} 
					this.getMunicipalList(res)
				},
				immediate: true
			},
			'form.municipal_code': {
				handler(res) {
					this.countyOption = [];
					if (!this.isUpdateInitRegion) {
						this.form.county_code = '';
						this.isUpdateInitRegion = true
					}
					this.HttpUtil.Get(this.api.common.regionList, {
						limit: 0,
						pcode: res
					}, {}, {
						commonApi: true
					}).then(res => {
						this.countyOption = res.list
					})
				},
			},
			progress: {
				handler(res) {
					if (res == 100) {
						let that = this
						setTimeout(function() {
							that.showProgress = false
							that.progress = 0
						}, 1000)
					}
				},
			},
			progress2: {
				handler(res) {
					if (res == 100) {
						let that = this
						setTimeout(function() {
							that.showProgress2 = false
							that.progress2 = 0
						}, 1000)
					}
				},
			},
			progressVideo: {
				handler(res) {
					if (res == 100) {
						let that = this
						setTimeout(function() {
							that.showProgressVideo = false
							that.progressVideo = 0
						}, 1000)
					}
				},
			},
			progressAudio: {
				handler(res) {
					if (res == 100) {
						let that = this
						setTimeout(function() {
							that.showProgressAudio = false
							that.progressAudio = 0
						}, 1000)
					}
				},
			},
		}
	}
</script>

<style scoped="scoped">
	.store-container {
		width: 75vw;
		min-width: 1000px;
		background-color: white;
		/* height: 650px; */
		margin: 0 auto;
		padding: 20px 10px 20px 25px;
		/* box-shadow: 0 0 100px rgba(31, 180, 249, 0.26); */
		box-sizing: border-box;
		margin-bottom: 30px;
	}

	.store-from-title {
		font-weight: bold;
		font-size: 20px;
		margin-top: 10px;
		margin-bottom: 20px;
		margin-left: 20px;
	}

	.store-from {
		margin-bottom: 20px;
		overflow-y: scroll;
		font-size: 14px;
		color: #333333;
	}

	.store-from-content {
		width: 100%;
	}

	/* 作者自荐 */
	.introduction {
		border: 1px solid #E5E5E5;
	}

	.introduction-line {
		width: 95%;
		height: 1px;
		background-color: #E5E5E5;
		margin: 10px auto;
	}

	.introduction-check-content {
		overflow: hidden;
	}

	/* 自荐标签选中 */
	.introduction-check-active {
		/* width: 110px; */
		padding: 0 26px;
		height: 42px;
		line-height: 42px;
		background: #D9F1FF;
		border-radius: 100px;
		color: #1FB4F9;
		text-align: center;
		font-weight: 400;
		cursor: pointer;
		float: left;
		margin-left: 10px;
		margin-top: 5px;
	}

	.introduction-check {
		/* width: 108px; */
		padding: 0 25px;
		height: 40px;
		background: #FFFFFF;
		border: 1px solid #E5E5E5;
		border-radius: 90px;
		text-align: center;
		color: #666666;
		font-weight: 400;
		cursor: pointer;
		float: left;
		margin-left: 10px;
		margin-top: 5px;
	}

	.introduction /deep/ .el-textarea__inner {
		border: none !important;
	}

	.store-from /deep/ .el-form-item__label {
		color: #333333 !important;
	}

	.el-checkbox.is-bordered+.el-checkbox.is-bordered {
		margin-left: 0;
	}

	.store-text {
		font-size: 12px;
		color: #666666;
	}

	/* 下载按钮 */
	.upload-button .el-button {
		width: 90px;
		height: 33px;
		border: 1px solid #FF3B3D;
		border-radius: 5px !important;
		font-weight: 400;
		color: #FF3B3D;
		border-radius: 0;
		font-size: 16px;
		margin-bottom: 10px;
		padding: 0;
		text-align: center;
		line-height: 33px;
	}
	.upload-button .el-button:hover {
		background: #FF3B3D;
		color: #FFFFFF;
	}
	.el-checkbox__input.is-checked .el-checkbox__inner {
		border-radius: 50%;
	}
	#wangeditor {
		z-index: 1;
	}
	/* 翻页 */
	.text-content {
		margin-top: 5px;
		width: 100%;
		text-align: center;
		display: flex;
		height: 30px;
		line-height: 30px;
	}
	
	.text-content .text {
		flex: 1;
		color: #5485fc;
		cursor: pointer;
		font-size: 14px;
		border-top: 1px solid #ececec;
	}
	
	.search_style {
		color: #5485fc;
		list-style: none;
		font-size: 14px;
		padding-left: 0;
		text-align: center;
		vertical-align: middle;
		height: 40px;
		line-height: 40px;
		margin-right: 10px;
	}
	.el_input_top_border /deep/ .el-input__suffix i {
		display: none;
	}
	.dialog-div-pre-style /deep/ .el-dialog__body {
		overflow-y: auto;
	}
	.circular-checkbox /deep/ .el-checkbox__inner{
		border-radius: 50%;
	}
</style>
